/*
 * useFormattedOrderItems - this hook is used to structure the product data which is then shown to FE
 */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getItemProperties, getLensPackages, getCategoryId, getLensPackagesDataManager } from '@utils/services';
import { useDispatch } from 'react-redux';
import { setFormattedOrderItems, errorLoading, endLoading, setShowSessionModal } from '@redux-actions/';
import { convertNumber, isValidJson, handleHTTPError } from '@utils/utils';
import { isMobile } from '@utils/utils';
import { getPrescription } from '@utils/services';
import * as actions from '@redux-actions/'
import { getMockFrameProperties, getMockLensesProperties } from '@utils/mockUtils';

const PRODUCT_URL = '/search/resources/store/15951/productview/byId/';

const CLEARANCE_URL = '/search/resources/store/15951/categoryview/gl_clearance';

const useFormattedOrderItems = (elementToWatch) => {
    const dispatch = useDispatch();
    //get configuration from redux store
    const config = useSelector(state => state.cart.config);

    /* getInnerProperties - this function is used to get all the properties of a frame or a lenses */
    const getInnerProperties = (frame, type) => {
        if(frame && frame.catalogEntryView[0] && frame.catalogEntryView[0].attributes) {
            let obj = {}
            frame.catalogEntryView[0].attributes.forEach(attr => {
                if(attr.values!=undefined){
                    if(Array.isArray(attr.values)){
                        obj[attr.name.toLowerCase().replace(/ /g, '')] = attr.values[0].value;
                    }else{
                        obj[attr.name.toLowerCase().replace(/ /g, '')] = attr.values.value;
                    }
                }
            })
    
            obj['buyable_' + type] = !!frame.catalogEntryView[0].buyable ? frame.catalogEntryView[0].buyable : '';
            obj['partNumber_' + type] = !!frame.catalogEntryView[0].partNumber ? frame.catalogEntryView[0].partNumber : '';
            return obj;
        } else {
            return {}
        }
    }

    const getBrand = (parentFrame) =>{
        let brand ="";
        if(parentFrame && parentFrame.catalogEntryView[0] && parentFrame.catalogEntryView[0].attributes) {
            parentFrame.catalogEntryView[0].attributes.forEach(attr => {
            if(attr.name && String(attr.name).toUpperCase().replace(/ /g, '') === 'BRAND'){
                    brand=attr.values[0].value;
            }
        })
        }
        return brand;
    }

        const getbadgeChannel = (parentFrame) =>{
        let brand ="";
        if(parentFrame && parentFrame.catalogEntryView[0] && parentFrame.catalogEntryView[0].attributes) {
            parentFrame.catalogEntryView[0].attributes.forEach(attr => {
            if(attr.name && String(attr.name).toUpperCase().replace(/ /g, '') === 'BADGE_CHANNEL'){
                    brand=attr.values[0].value;
            }
        })
        }
        return brand;
    }
    
    
   const getModelName = (parentFrame) =>{
        let brand ="";
        if(parentFrame && parentFrame.catalogEntryView[0] && parentFrame.catalogEntryView[0].attributes) {
            parentFrame.catalogEntryView[0].attributes.forEach(attr => {
            if(attr.name && String(attr.name).toUpperCase().replace(/ /g, '') === 'MODEL_NAME'){
                    brand=attr.values[0].value;
            }
        })
        }
        return brand;
    }

    /* check if adjustment derives from promoCode */
    const isPromoCode = (itemAdjustment) =>{
        let filteredAdj=[];
        for (let i = 0; i < itemAdjustment.length; i++) {
            let promoId=itemAdjustment[i].code;
            if(elementToWatch.promotionCode!=undefined){
                for (let j = 0; j < elementToWatch.promotionCode.length; j++) {
                    let promoCodeid=elementToWatch.promotionCode[j].associatedPromotion[0].promotionId
                    if(promoId.includes(promoCodeid)){
                        itemAdjustment=itemAdjustment.slice(0, i).concat(itemAdjustment.slice(i+1))
                    }
                }
            }

        }
        return itemAdjustment;
    }

    const isOpthyCode = () => {
        let isOpthy = false;
        if(!elementToWatch.promotionCode || elementToWatch.promotionCode.length === 0) return false;
        elementToWatch.promotionCode.forEach(el => {
            if(el.code.toUpperCase() == config.opthyPromoCode.toUpperCase()) {
                isOpthy = true;
            }
        });
        return isOpthy;
      }
    
    /* getTotalAdjustmentSubItem - this function is used to get the total amount of the adjustment of the frame or lenses of an item, and all the frame or lenses codes and descriptions*/
    const getTotalAdjustmentSubItem = (adjustment) => {
        let adj = {
            amount: 0,
            code: []
        };

        if( !adjustment || adjustment.length === 0) return adj;

        var itemAdjustment = adjustment.filter(adj => adj.displayLevel !== 'Order');
        itemAdjustment=isPromoCode(itemAdjustment);

        if(itemAdjustment.length === 0) return adj;

        for(let i = 0; i < itemAdjustment.length; i++) {
            adj.amount = adj.amount + parseFloat(itemAdjustment[i].amount);
            adj.code.push({
                code: itemAdjustment[i].code,
                description: !!itemAdjustment[i].description ? itemAdjustment[i].description : itemAdjustment[i].code
            });
        }

        return adj;
    }

    /* getTotalAdjustmentAddons -  this function is used to get the total amount of the adjustment of the addon of an item, and all the addon codes and descriptions*/
    const getTotalAdjustmentAddons = (addOnsItems) => {
        if(addOnsItems.length === 0) {
            return {
                amount: 0,
                code: []
            }
        }
        
        const orderLevelAdj = addOnsItems.map(add => {
            return getTotalAdjustmentSubItem(add.adjustment);
        });
        
        let amount = 0;
        let codes = [];

        orderLevelAdj.forEach(item => {
            if(!!item.code && item.code.length > 0) {
                amount = amount + parseFloat(item.amount);
                const isFind = codes.find(c => c.code === item.code[0].code);
                
                if(isFind === undefined) {
                    codes.push({
                        code: item.code[0].code,
                        description: !!item.code[0].description ? item.code[0].description : item.code[0].code
                    });
                }
            }            
        });

        return {
            amount: amount,
            code: codes
        }
    }

    /* getOrderedRxcReviewObject - this function is used to get and order by 'sequence', the properties of the object shown in 'Your Lenses' section */
    const getOrderedRxcReviewObject = (xitem_rxcReviewObject) => {
       const rxcReviewObject = JSON.parse(xitem_rxcReviewObject);
       if(rxcReviewObject === null) return null;
       return Object.keys(rxcReviewObject).map(function (key) { return rxcReviewObject[key]; }).sort((a, b) => (a.sequence > b.sequence) ? 1 : -1);
    }

    const getOrderedUpsellOptionObject = (upsellOpions) => {
        if(upsellOpions === null) return null;
        return Object.keys(upsellOpions).map(function (key) { return upsellOpions[key]; });
    }

    const getCurrentLensPackage = (lensId, lensPackages) => {
        var currentPackage = null;
        if(!!lensPackages["m_" + lensId]){
            currentPackage = lensPackages["m_" + lensId];
        }

        return currentPackage;
    }

    /* getPrices -  this function is used to retrieve all the prices for a frame or a lenses */
    const getPrices = (item) => {
        const xitem_basePrice = !!item.xitem_basePrice ? convertNumber(item.xitem_basePrice) : convertNumber(item.unitPrice);
        const unitPrice = convertNumber(item.unitPrice);
        const totalAdjustment = getTotalAdjustmentSubItem(item.adjustment);
        let finalPrice = parseFloat(xitem_basePrice);
        let finalDiscountPrice = parseFloat(unitPrice);

        let hasPromotions = false;
        if(xitem_basePrice !== unitPrice) {
            hasPromotions = true;
        }

        if(totalAdjustment.amount !== 0) {
            hasPromotions = true;
            finalDiscountPrice = finalDiscountPrice + totalAdjustment.amount
        }

        return {
            xitem_basePrice: xitem_basePrice,
            unitPrice: unitPrice,
            totalAdjustment: totalAdjustment,
            finalPrice: finalPrice.toFixed(2),
            finalDiscountPrice: finalDiscountPrice.toFixed(2),
            hasPromotions: hasPromotions
        }
    }

    /* getAddOnPrices - this function is used to retrieve all the prices for addons */
    const getAddOnPrices = (addOnsItems) => {
        const totalXItem_basePrice = addOnsItems.reduce((total, item) => {
            return total + !!item.xitem_basePrice ? parseFloat(item.xitem_basePrice) : parseFloat(item.unitPrice);
        }, 0);
        const totalXItem_unitPrice = addOnsItems.reduce((total, item) => {
                return total + parseFloat(item.unitPrice);
        }, 0);
        const totalAdjustment = getTotalAdjustmentAddons(addOnsItems);
        let finalPrice = parseFloat(totalXItem_unitPrice);
        let finalDiscountPrice = parseFloat(totalXItem_unitPrice);

        let hasPromotions = false;

        if(totalXItem_basePrice !== totalXItem_unitPrice) {
            hasPromotions = true;
        }

        if(totalAdjustment.amount !== 0) {
            hasPromotions = true;
            finalDiscountPrice = finalDiscountPrice + totalAdjustment.amount
        }

        return {
            totalXItem_basePrice: totalXItem_basePrice,
            totalXItem_unitPrice: totalXItem_unitPrice,
            totalAdjustment: totalAdjustment,
            finalPrice: finalPrice.toFixed(2),
            finalDiscountPrice: finalDiscountPrice.toFixed(2),
            hasPromotions: hasPromotions
        }
    }
    
    const lensPackageComputation = async(lensPackages, item, lenseItem, lensPrices, prescription) => {
        let upsellOpions: any = {};
        
        var dataInput = {
            _currentPackage: lenseItem.productId,
            _packages: lensPackages.packages,
            _content: lensPackages.content,
            _prescriptionObject: prescription,
            _imagery: !!item.xitem_rxcImagery && isValidJson(item.xitem_rxcImagery) ? JSON.parse(item.xitem_rxcImagery) : null,
            _config: !!item.xitem_rxcUpsellConfig && isValidJson(item.xitem_rxcUpsellConfig) ? JSON.parse(item.xitem_rxcUpsellConfig) : null,
            _prices: lensPrices?.prices
        }
        await config.callFromComponentToGl.getUpsellOptions(dataInput).then((responseUpsell) => {
                responseUpsell.forEach(element => {
                    if(!!element && !!item.xitem_rxcReviewObject)
                        element.reviewObject.AdvancedPrescription = JSON.parse(item.xitem_rxcReviewObject).AdvancedPrescription;
                });
                if(typeof(responseUpsell) == 'object'){
                    if(isMobile.any()){
                    //Rule to show one item in mobile (BL -> AR -> Auth. lenses)
                    //We know that at 2th position there's blue light, 1th position there's antirefl
                        if(responseUpsell[1] != null){
                        //BLULIGHT LENS
                            upsellOpions = [responseUpsell[1]];
                        }else{
                            if(responseUpsell[0] != null){
                            //ANTIREFLECTIVE LENS
                                upsellOpions = [responseUpsell[0]];
                            }else{
                                if(responseUpsell[2] != null){
                                    //AUTH LENS
                                    upsellOpions = [responseUpsell[2]];
                                }
                            }
                        }
                    }else{
                        upsellOpions = responseUpsell.filter(upsell => upsell != null);
                    }
                }else{
                    upsellOpions = [];
                }
            }).catch((e)=> {
                console.error('>>> Get upsell options error:', e);
                upsellOpions = [];
            });

        return upsellOpions;
    }

    /* this hooks is called every time the 'elementToWatch' passed change */
    useEffect(() => {
        if(!!elementToWatch && !!elementToWatch.orderItem) {
            //get all the frames in the cart
            let items = elementToWatch.orderItem.filter(item => item.comments === 'SUN' || item.comments === 'EYE');
            items = items.sort((a, b) => parseFloat(b.orderItemId) - parseFloat(a.orderItemId));
           
            Promise.all(items.map(async (item) => {
                //for each frame, get its lenses and addons
                const lenseItem = elementToWatch.orderItem.find(i => i.xitem_field1 === item.orderItemId && i.comments === 'LENS');
                const addOnsItems = elementToWatch.orderItem.filter(i => i.xitem_field1 === item.orderItemId && i.comments === 'ADD');

                let lensPackages = {};
                let currentPackage = null;
                //if the item is an rx item and already has prescription, get the prescription
                let prescription = {};
                
                const frameProductUrl = !!item.productUrl ? item.productUrl : config.hostname + PRODUCT_URL + item.productId;
                //call to get the 'inner properties' of the frame
                const frame = config.mockRequests === true ?
                        await getMockFrameProperties() :
                        !!frameProductUrl ? 
                            await getItemProperties(frameProductUrl)
                                    .catch(err => {
                                        console.error('>>> Get frame item properties => error status:', err.status, ', error: ', err);
                                        handleHTTPError(dispatch, actions, err);
                                    }) 
                            : null;

                const frameCategories= frame.catalogEntryView[0].parentCatalogGroupID;           
                const clearanceId = await getCategoryId(CLEARANCE_URL);

                const isClearance = frameCategories.includes(config.catalogId+"_"+clearanceId.catalogGroupView[0].uniqueID);

                const frameParentProductURL = config.hostname  + PRODUCT_URL + frame.catalogEntryView[0].parentCatalogEntryID;
                                
				const parent_frame = config.mockRequests === true ?
                        await getMockFrameProperties() :
                        !!frameParentProductURL ? 
                            await getItemProperties(frameParentProductURL)
                                    .catch(err => {
                                        console.error('>>> Get frame item properties => error status:', err.status, ', error: ', err);
                                        handleHTTPError(dispatch, actions, err);
                                    }) 
                            : null;
				
				
                const lenseProductUrl = !!lenseItem && !!lenseItem.productUrl ? lenseItem.productUrl : config.hostname + PRODUCT_URL + lenseItem.productId;

                //call to get the 'inner properties' of the lenses
                const lense = config.mockRequests === true ? 
                        await getMockLensesProperties() :
                        !!lenseProductUrl ? 
                        await getItemProperties(lenseProductUrl)
                                .catch(err => {
                                    console.error('>>> Get lenses item properties => error status:', err.status, ', error: ', err);
                                    handleHTTPError(dispatch, actions, err);
                                })
                        : null;

                if(!!item.xitem_frameType && !!item.xitem_prescriptionComplete && item.xitem_frameType === 'RX' && item.xitem_prescriptionComplete === 'true') {
                    await getPrescription(config.hostname, lenseItem.orderItemId)
                            .then((res: any) => {
                                if(res.status === 200) {
                                    prescription = res.data.response;
                                }
                            })
                            .catch(err => {
                                console.error('>>> Get prescription => error status:', err.status, ', error: ', err);
                                handleHTTPError(dispatch, actions, err);
                            })
                }
                let packageData: any = {};
                let responseSessionStorage = sessionStorage.getItem("lens-package-current-session-" + item.productId);

                let moCo = parent_frame.catalogEntryView[0].partNumber.split("__")[0];
                let lensPrices = null;

                await getLensPackages(config.hostname, item.productId, config.catalogId).then(async(response) => {
                    if(!!response){
                        lensPrices = response;
                    }
                }).catch(err => {
                    console.error('>>> Get frame lens prices => error status:', err.status, ', error: ', err);
                    handleHTTPError(dispatch, actions, err);
                })

                if(!responseSessionStorage){
                    await getLensPackagesDataManager(config.packagesUrl, moCo).then(async(response) => {
                        if(!!response) {
                            try{
                                sessionStorage.setItem("lens-package-current-session-" + item.productId, JSON.stringify(response));
                            }catch(e){
                                console.error('LocalStorage bound exception! Out of memory', e.status, ', error: ', e);
                            }
                            lensPackages = response;
                            currentPackage = getCurrentLensPackage(lenseItem.partNumber, lensPackages);

                            if (config.cartLensUpsell.enabled === true) {
                                packageData = await lensPackageComputation(lensPackages, item, lenseItem, lensPrices, prescription);
                            }
                        }
                    }).catch(err => {
                        console.error('>>> Get frame lens packages => error message:', err.message, ', error: ', err);
                        handleHTTPError(dispatch, actions, err);
                    })
                } else {
                    lensPackages = JSON.parse(responseSessionStorage);
                    currentPackage = getCurrentLensPackage(lenseItem.partNumber, lensPackages);

                    if (config.cartLensUpsell.enabled === true) {
                        packageData = await lensPackageComputation(lensPackages, item, lenseItem, lensPrices, prescription);
                    }
                }

                return {
                    frame: {
                        productId: item.productId,
                        partNumber: item.partNumber,
                        orderItemId: item.orderItemId,
                        quantity: item.quantity,
                        ...getPrices(item),
                        currency: item.currency,
                        xitem_frameType: !!item.xitem_frameType ? item.xitem_frameType : '',
                        xitem_prescriptionComplete: !!item.xitem_prescriptionComplete ? item.xitem_prescriptionComplete : null,
                        xitem_rxcReviewObject: !!item.xitem_rxcReviewObject && isValidJson(item.xitem_rxcReviewObject) ? getOrderedRxcReviewObject(item.xitem_rxcReviewObject) : null,
                        xitem_rxcUpsellConfig: !!item.xitem_rxcUpsellConfig && isValidJson(item.xitem_rxcUpsellConfig) ? JSON.parse(item.xitem_rxcUpsellConfig) : null,
                        hasInsuranceApplied: !!item.adjustment ? item.adjustment.find(adj => adj.code === 'INSADJ') !== undefined || RiaHelper.getCookie('ria_1')!='' ? true : false : RiaHelper.getCookie('ria_1')!='' ? true : false,
                        hasInsuranceCalculated: !!item.adjustment ? item.adjustment.find(adj => adj.code === 'INSADJ') !== undefined && RiaHelper.getCookie('ria_1')!='' ? true : false : false,
                        xitem_rxcImagery: !!item.xitem_rxcImagery && isValidJson(item.xitem_rxcImagery) ? JSON.parse(item.xitem_rxcImagery) : null,
                        xitem_laResults: !!item.xitem_laResults && isValidJson(item.xitem_laResults) ? JSON.parse(item.xitem_laResults) : null,
                        xitem_imgUrl: !!item.xitem_imgUrl ? item.xitem_imgUrl : null,
                        category: item.comments,
                        isClearance: isClearance
                    },
                    lenses: {
                        ...getPrices(lenseItem),
                        productId: !!lenseItem ? lenseItem.productId : null,
                        orderItemId: !!lenseItem ? lenseItem.orderItemId : null,
                        xitem_field1: !!lenseItem && !!lenseItem.xitem_field1 ? lenseItem.xitem_field1 : null,
                        xitem_field2: !!lenseItem && !!lenseItem.xitem_field2 ? lenseItem.xitem_field2 : null,
                        xitem_correctionType: !!lenseItem && !!lenseItem.xitem_correctionType ? lenseItem.xitem_correctionType : null,
                        xitem_rxcLensIsSpeedyRx: !!lenseItem && !!lenseItem.xitem_rxcLensIsSpeedyRx ? lenseItem.xitem_rxcLensIsSpeedyRx : null,
                    },
                    addOns: {
                        ids: addOnsItems.map(add => add.productId),
                        partNumbers: addOnsItems.map(add => add.partNumber),
                        ...getAddOnPrices(addOnsItems),
                    },
                    lensesAddonsIds: [lenseItem.productId].concat(addOnsItems.map(add => add.productId)),
                    prescription: {
                        ...prescription
                    },
                    lensPackages: {
                        ...lensPackages
                    },
                    currentPackage: {
                        ...currentPackage
                    },
                    upsellOpions: [
                        ...getOrderedUpsellOptionObject(packageData)
                    ],
                    /* @ts-expect-error */
                    modelName: getModelName(parent_frame),
                    ...getInnerProperties(frame, 'frame'),
                    moCo: {...getInnerProperties(parent_frame,'moCo')},
                    ...getInnerProperties(lense, 'lenses'),
                    brand: getBrand(parent_frame),
                    badgeChannel: getbadgeChannel(parent_frame),
                    isOpthyCode: isOpthyCode()
                }
            })).then(res => {
                //save formattedOrderItems array into redux store
                dispatch(setFormattedOrderItems(res))
                dispatch(endLoading())
            }).catch(err => {
                console.error('>>> Formatted order items => error status:', err.status, ', error: ', err);
                handleHTTPError(dispatch, actions, err);
            });
        } else {
            if(elementToWatch !== null) {
                dispatch(errorLoading());
            }            
        }
       
    }, [elementToWatch]);
}

export default useFormattedOrderItems;
